import { Err } from '../classes/Err';
import type { Result, AppError } from '../types';

/**
 * @group Functions
 * @summary <blockquote>Creates a failed Result (Err) containing the given error.</blockquote>
 * @typeParam E - The type of the error (defaults to AppError).
 * @param error - The error to wrap in Err.
 * @returns An Err instance.
 * @example
 * ```typescript
 * const result = err('Something went wrong');
 * // Returns: Err('Something went wrong')
 * ```
 */
export function err<E = AppError>(error: E): Result<never, E> {
  return new Err(error);
} 